import { render } from "./TheAlarmsList.vue?vue&type=template&id=d95a20ee"
import script from "./TheAlarmsList.vue?vue&type=script&lang=js"
export * from "./TheAlarmsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__